import MinusMembershipHeading from './MinusMembershipHeading';

export default MinusMembershipHeading;
